// src/hooks/hotelRoomCategories/useGetHotelRoomCategories.js
import { useQuery } from "@tanstack/react-query";
import { getAllHotelRoomCategories } from "../../api/apiHotelRoomCategories";

const QUERY_KEY = ["hotelRoomCategories"];

const useGetHotelRoomCategories = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllHotelRoomCategories(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelRoomCategories: data?.data || data?.hotelRoomCategories || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetHotelRoomCategories;
